<script setup lang="ts">
type Props = { item?: CommentArticle | null }

const props = withDefaults(defineProps<Props>(), { item: null })

const app = useNuxtApp()
const router = useRouter()
const storeIndex = useStoreIndex()

const refData = reactive({
  loading: false,
  errorMessage: null,
  innerFormData: {
    id: null,
    name: '',
    title: '',
    comment: '',
    password: '',
    recaptcha: '',
  },
  isShowPassword: false,
  isValidForm: false,
})

const recaptcha = ref(null)

const onSubmit = () => {
  if (!refData.isValidForm) {
    return
  }
  refData.loading = true
  recaptcha.value.execute()
}

const onToken = async (token) => {
  refData.innerFormData.recaptcha = token
  refData.loading = true
  if (props.item) {
    try {
      const res = await app.$ArticleApi.articleCommentEdit(
        'imbbs',
        'static',
        refData.innerFormData.id,
        refData.innerFormData.name,
        refData.innerFormData.title,
        refData.innerFormData.comment,
        refData.innerFormData.password,
        refData.innerFormData.recaptcha,
      )
      if (res.data.code === 200000) {
        refData.errorMessage = null
        storeIndex.searchDeleteCache('imbbs')
        refData.loading = false
        router.replace('/imbbs')
        return
      }
      refData.innerFormData.password = null
      refData.errorMessage = (res.data.data as any).message + '(' + res.data.code + ')'
    } catch (e) {
      refData.innerFormData.password = null
      refData.errorMessage = 'エラーが発生しました'
    }
  } else {
    try {
      const res = await app.$ArticleApi.articleCommentAdd(
        'imbbs',
        'static',
        refData.innerFormData.name,
        refData.innerFormData.title,
        refData.innerFormData.comment,
        refData.innerFormData.password,
        refData.innerFormData.recaptcha,
      )
      if (res.data.code === 200000) {
        refData.errorMessage = null
        storeIndex.searchDeleteCache('imbbs')
        refData.loading = false
        router.replace('/imbbs')
        return
      }
      refData.innerFormData.password = null
      refData.errorMessage = (res.data.data as any).message + '(' + res.data.code + ')'
    } catch (e) {
      refData.innerFormData.password = null
      refData.errorMessage = 'エラーが発生しました'
    }
  }
  refData.loading = false
}

refData.errorMessage = null
if (props.item) {
  refData.innerFormData.id = props.item.id
  refData.innerFormData.name = props.item.name
  refData.innerFormData.title = props.item.title
  refData.innerFormData.comment = props.item.comment
}
</script>

<template>
  <div class="p-form">
    <div class="c-heading_error">
      <template
        v-if="refData.errorMessage"
      >
        {{ refData.errorMessage }}
      </template>
    </div>
    <v-form
      ref="vform"
      v-model="refData.isValidForm"
    >
      <div class="p-form_controls">
        <div class="p-form_inputBlock">
          <div class="p-form_inputBlock_labelRow">
            <div class="p-form_inputBlock_labelRow_text">
              名前
            </div>
          </div>
          <v-text-field
            v-model="refData.innerFormData.name"
            name="名前"
            variant="outlined"
            density="compact"
            single-line
            v-bind:rules="[app.$vvRequired, (value) => app.$vvMax(value, 22)]"
            counter="22"
            maxlength="22"
          />
        </div>

        <div class="p-form_inputBlock">
          <div class="p-form_inputBlock_labelRow">
            <div class="p-form_inputBlock_labelRow_text">
              件名
            </div>
          </div>

          <v-text-field
            v-model="refData.innerFormData.title"
            name="件名"
            variant="outlined"
            density="compact"
            single-line
            v-bind:rules="[app.$vvRequired, (value) => app.$vvMax(value, 100)]"
            counter="100"
            maxlength="100"
          />
        </div>

        <div class="p-form_inputBlock">
          <div class="p-form_inputBlock_labelRow">
            <div class="p-form_inputBlock_labelRow_text">
              コメント
            </div>
          </div>

          <v-textarea
            v-model="refData.innerFormData.comment"
            name="コメント"
            variant="outlined"
            v-bind:rules="[app.$vvRequired, (value) => app.$vvMax(value, 10000)]"
            counter="10000"
            maxlength="10000"
          />
        </div>

        <div class="p-form_inputBlock">
          <div class="p-form_inputBlock_labelRow">
            <div class="p-form_inputBlock_labelRow_text">
              パスワード
            </div>
          </div>

          <v-text-field
            v-model="refData.innerFormData.password"
            name="パスワード"
            variant="outlined"
            density="compact"
            single-line
            hint="※編集・削除時に必要となります。"
            v-bind:rules="[app.$vvRequired, (value) => app.$vvMax(value, 20), app.$vvImPassword]"
            maxlength="20"
            v-bind:append-inner-icon="refData.isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:type="refData.isShowPassword? 'text' : 'password'"
            v-on:click:append-inner="refData.isShowPassword = !refData.isShowPassword"
          />
        </div>

        <Recaptcha
          id="recaptcha"
          ref="recaptcha"
          v-on:token="onToken"
        />

        <div
          class="p-form_action"
        >
          <v-btn
            class="c-btn_formSubmit"
            v-bind:disabled="!refData.isValidForm"
            v-bind:loading="refData.loading"
            color="primary"
            v-on:click="onSubmit"
          >
            <v-icon>mdi-file-document-edit-outline</v-icon>
            <template
              v-if="item"
            >
              変更
            </template>
            <template
              v-else
            >
              投稿
            </template>
          </v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
</style>
